import React from "react";
import { useAppContext } from "../../context/AppContext";
import { Link } from "react-router-dom";
import Transition from "../../components/Transition";
import { AnimatePresence } from "framer-motion";


export default function Landing() {
    const { appData } = useAppContext();
    return (
        <div className="vh-100">
            <div className="container-fluid d-flex flex-column justify-content-center align-items-center h-100 text-center p-4">
                <div className="nav-header rounded mb-4">
                    <Link to="/" className="brand-logo d-flex align-items-center justify-content-center">
                        <img className="rounded" src={appData.logo} alt="Logo" width="60" height="60" />
                        {/*<h2 className="text-primary ms-3">{appData.name}</h2> */}
                    </Link>
                </div>

                <div className="text-center">
                    <AnimatePresence mode="wait">
                        <Transition key={"landing-page"}>
                            <h1 className="display-4 mb-3 text-black">Welcome to <span className="text-primary">{appData.name}</span> Mobile EA Management</h1>
                            <p className="fs-18 text-muted mb-4">{appData.description}</p>
                            <Link to="/login" className="btn btn-primary px-4 py-2 me-2">Login</Link>
                            <Link to="/register" className="btn btn-outline-primary px-4 py-2">Get Started</Link>
                        </Transition>
                    </AnimatePresence>
                </div>
            </div>
        </div>
    );
}